import React, { FunctionComponent } from 'react'
import healthCheckLight from '../../assets/img/brief-thumb-health-check.svg'
import healthCheckDark from '../../assets/img/brief-thumb-health-check-dark.svg'
import fleetMakeupLight from '../../assets/img/brief-thumb-fleet-makeup.svg'
import fleetMakeupDark from '../../assets/img/brief-thumb-fleet-makeup-dark.svg'
import securityLight from '../../assets/img/brief-thumb-security.svg'
import securityDark from '../../assets/img/brief-thumb-security-dark.svg'
import styles from './BriefThumb.module.css'

/*
 * A brief's thumbnail, in the current theme. Both versions are in the page and CSS shows the one that
 * matches, so switching theme swaps them straight away.
 */
const THUMBS = {
  'health-check': { light: healthCheckLight, dark: healthCheckDark },
  'fleet-makeup': { light: fleetMakeupLight, dark: fleetMakeupDark },
  security: { light: securityLight, dark: securityDark },
}

interface Props {
  brief: keyof typeof THUMBS
  className?: string
}

export const BriefThumb: FunctionComponent<Props> = ({ brief, className = '' }) => (
  <>
    <img src={THUMBS[brief].light} alt='' className={`${className} ${styles.lightOnly}`} />
    <img src={THUMBS[brief].dark} alt='' className={`${className} ${styles.darkOnly}`} />
  </>
)
